import { HeaderBar } from "../components/header-bar";
import { FooterBar } from "../components/footer-bar";
import { ContentBox } from "../components/content-box";
import { Link } from "react-router-dom";

const Dokument = ({ filename, text, extraText }: { filename: string; text: string; extraText?: string }) => {
  return (
    <li>
      <Link
        to={`${process.env.PUBLIC_URL}/protokoll/${filename}`}
        target="_blank"
      >
        {text}
      </Link>
      {extraText && <span>{' '}{extraText}</span>}
      </li>
  );
};

export const PageProtocol = () => {
  return (
    <>
      <HeaderBar />
      <ContentBox>
        <h3>2025</h3>
        <ul>
          <Dokument
            filename="2025-protokoll.pdf"
            text="Protokoll årsmöte 2025"
          />
          <Dokument
            filename="2025-extrastammans-protokoll.pdf"
            text="Extrastammans protokoll" extraText="angående val av elladdningsföretag"
          />
        </ul>

        <h3>2024</h3>
        <ul>
          <Dokument
            filename="2024-protokoll.pdf"
            text="Protokoll årsmöte 2024"
          />
        </ul>

        <h3>2023</h3>
        <ul>
          <Dokument
            filename="2023-kallelse.pdf"
            text="Kallelse till årsmöte 2023"
          />
          <Dokument
            filename="2023-protokoll.pdf"
            text="Protokoll årsmöte 2023"
          />
        </ul>

        <h3>2022</h3>
        <ul>
          <Dokument
            filename="2022-protokoll.pdf"
            text="Protokoll årsmöte 2022"
          />
        </ul>

        <h3>2021</h3>
        <ul>
          <Dokument
            filename="2021-protokoll.pdf"
            text="Protokoll årsmöte 2021"
          />
        </ul>

        <h3>2020</h3>
        <ul>
          <Dokument
            filename="2020-protokoll.pdf"
            text="Protokoll årsmöte 2020"
          />
        </ul>

        <h3>2019</h3>
        <ul>
          <Dokument
            filename="2019-protokoll.pdf"
            text="Protokoll årsmöte 2019"
          />
        </ul>

        <h3>2018</h3>
        <ul>
          <Dokument
            filename="2018-kallelse.pdf"
            text="Kallelse till årsmöte 2018"
          />
          <Dokument
            filename="2018-protokoll.pdf"
            text="Protokoll årsmöte 2018"
          />
        </ul>

        <h3>2017</h3>
        <ul>
          <Dokument
            filename="2017-protokoll.pdf"
            text="Protokoll årsmöte 2017"
          />
          <Dokument
            filename="2017-verksamhetsberattelse.pdf"
            text="Verksamhetsberättelse 2017"
          />
        </ul>

        <h3>2016</h3>
        <ul>
          <Dokument
            filename="2016-kallelse.pdf"
            text="Kallelse till årsmöte 2016"
          />
          <Dokument
            filename="2016-protokoll.pdf"
            text="Protokoll årsmöte 2016"
          />
          <Dokument
            filename="2016-verksamhetsberattelse.pdf"
            text="Verksamhetsberättelse 2016"
          />
        </ul>

        <h3>2015</h3>
        <ul>
          <Dokument
            filename="2015-protokoll.pdf"
            text="Protokoll årsmöte 2015"
          />
        </ul>

        <h3>2014</h3>
        <ul>
          <Dokument
            filename="2014-protokoll.pdf"
            text="Protokoll årsmöte 2014"
          />
          <Dokument
            filename="2014-verksamhetsberattelse.pdf"
            text="Verksamhetsberättelse 2014"
          />
        </ul>

        <h3>2013</h3>
        <ul>
          <Dokument
            filename="2013-protokoll.pdf"
            text="Protokoll årsmöte 2013"
          />
        </ul>

        <h3>2012</h3>
        <ul>
          <Dokument
            filename="2012-kallelse.pdf"
            text="Kallelse till årsmöte 2012"
          />
        </ul>

        <p>
          Vill du ha annan information, använd kontaktsidan och berätta, så
          fixar vi det.
        </p>
      </ContentBox>
      <FooterBar />
    </>
  );
};
